import type { FeatureCardProps } from "../../types/categories"

const FeatureCard: React.FC<FeatureCardProps> = ({ feature, onTap }) => {
    return (
        <div
            className="flex flex-col items-center p-2 sm:p-3 rounded-xl bg-primary-default shadow-sm hover:shadow-md transition-all w-full cursor-pointer"
            onClick={onTap}
        >
            <div className="w-8 h-8 sm:w-12 sm:h-12 rounded-full bg-primary-tertiary flex items-center justify-center mb-1 sm:mb-2">
                {feature.icon}
            </div>
            <span className="text-[10px] sm:text-xs font-medium text-primary-contrast text-center">
                {feature.title}
            </span>
        </div>
    )
}

export default FeatureCard 